import React, { Fragment, useState, PureComponent } from 'react'
import axios from 'axios'
import classNames from 'classnames'
import { PieChart, Pie, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ByteType } from 'three';


const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const toPercent = (percent, fixed = 0) => {
	return `${(percent).toFixed(fixed)} %`;
};

const Bet = (props) => {

  const height = props.height ? props.height : 400
  const fill = props.fill ? props.fill : "#0088FE"
  const colors = props.colors ? props.colors : ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  const bet = props.bet

  function pie() {
    return (
      <div style={{width: "100%", height: props.height}}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              isAnimationActive={false}
              labelLine={false}
              label={renderCustomizedLabel}
              dataKey="value"
              outerRadius={80}
              data={props.data}
            >
              {
                props.data.map((entry, index) => {
                  return (<Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
                })
              }
            </Pie>
            {props.children}
          </PieChart>
        </ResponsiveContainer>
      </div>
    )
  }

  function bar() {
    return (

      <div style={{ width: "80%", height: props.height, marginTop: "20px" }}>
        <ResponsiveContainer>

          <BarChart width={100} height={40} data={props.data}>

            <Bar
              dataKey="value" 
            >
              {
                props.data.map((entry, index) => {
                  return (<Cell fill={colors[index % colors.length]} />)
                })
              }
            </Bar>
            <XAxis dataKey="name"/>
            <YAxis tickFormatter={toPercent}/>

          </BarChart>

        </ResponsiveContainer>

      </div>
    )
  }
  if (bet != undefined) {
    switch(bet.result_chart_type) {
      case "pie":
        return pie();
      case "bar":
        return bar();
      default:
        return pie();
    }
  } else {
    return pie();
  }
  
}
export default Bet